// initial state
const state = () => ({
    account: undefined,
    native: {
        balance: null,
        wei: null,
    },
    balances: {},
    weiBalances: {},
});

// getters
const getters = {};

// mutations
const mutations = {
    setAccount(state, account) {
        [state.account] = account;
    },

    setNative(state, native) {
        state.native = native;
    },

    setContractWeiBalance(state, payload) {
        state.weiBalances[payload.contract] = payload.balance;
    },

    setContractBalance(state, payload) {
        state.balances[payload.contract] = payload.balance;
    }
    
};

// actions
const actions = {
    async getAccount({ commit, rootState, dispatch }) {
        commit('setAccount', await rootState.web3.instance.eth.getAccounts());
        // dispatch('updateNativeBalance');
    },

    async getWalletBalance({ dispatch, commit, state, rootState }, contract) {
        if (typeof rootState.contracts[contract].instance.methods.balanceOf !== "function") {return;}
        let weiBalance = await dispatch('contracts/getContractWeiBalance', {contract: contract, account: state.account}, {root:true});
        commit('setContractWeiBalance', {contract: contract, balance: weiBalance});
        if (rootState.contracts[contract].decimals !== null) {weiBalance = (weiBalance/10**rootState.contracts[contract].decimals);}
        commit('setContractBalance', {contract: contract, balance: weiBalance});
        // dispatch('events/walletBalanceUpdate', contract, {root:true});
    },

    // async updateNativeBalance({ dispatch, commit, state, rootState }) {
    //     let native = {
    //         wei: await rootState.web3.instance.eth.getBalance(state.account),
    //         balance: null,
    //     };
    //     native.balance = (native.wei / 10**18);
    //     commit('setNative', native);
    // },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};